import { render, staticRenderFns } from "./CoverGenius.vue?vue&type=template&id=1f7cdee8&scoped=true&"
import script from "./CoverGenius.vue?vue&type=script&lang=ts&"
export * from "./CoverGenius.vue?vue&type=script&lang=ts&"
import style0 from "./CoverGenius.vue?vue&type=style&index=0&id=1f7cdee8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f7cdee8",
  null
  
)

export default component.exports